export const TOJ_COLOR_HEX = '#dc2626'
export const TOJ_CUSTOMER_COLOR_HEX = '#fde047'
export const ADVISORY_COLOR_HEX = '#9333ea'
export const WORKSHOP_COLOR_HEX = '#0891b2'
export const PILOT_COLOR_HEX = '#16a34a'
